import * as breakpoints from "../breakpoints";
import * as colors from "../constants/colors";
import * as languages from "../constants/languages";
import { css, StyleSheet } from "aphrodite";
import { english, spanish } from "../constants/strings";
import PropTypes from "prop-types";
import React, { Component } from "react";
import typeColors from "../constants/typeColors";
import categoryColors from "../constants/categoryColors";

const styles = StyleSheet.create({
	link: {
		textDecoration: "none",
	},
	accessibilityLink: {
		paddingTop: 12,
		display: "block",
	},
	courseTypeText: {
		fontSize: 11,
		height: 14,
		flexGrow: 1,
		flexShrink: 0,
		flexBasis: "auto",
		fontFamily: "freight-sans-pro",
		fontWeight: "bold",
		color: colors.black,
	},
	courseTypeBackground: {
		paddingLeft: 4,
		paddingRight: 4,
	},
	categoryText: {
		fontSize: 12,
		lineHeight: 1.25,
		minHeight: 15,
		color: colors.darkTeal,
		fontWeight: "normal",
		fontFamily:
			"TrebuchetMS, Trebuchet MS, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Tahoma,sans-serif",
		[breakpoints.mobileOnly]: {
			fontSize: 14,
			lineHeight: 1.07,
		},
		[breakpoints.desktopOnly]: {
			":hover": {
				cursor: "pointer",
			},
		},
	},
	container: {
		paddingTop: 16,
		paddingRight: 16,
		paddingBottom: 12,
		paddingLeft: 16,
		[breakpoints.desktopOnly]: {
			":hover": {
				cursor: "pointer",
			},
		},
	},
	courseTitle: {
		[breakpoints.tabletAndUp]: {
			height: 45,
		},
		fontSize: 18,
		color: colors.darkTeal,
		lineHeight: 1,
		fontWeight: "normal",
		fontFamily: "priori-sans, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
		display: "block",
		textDecoration: "underline",
		[breakpoints.mobileOnly]: {
			fontSize: 18,
			lineHeight: 0.83,
		},
	},
	infoContainer: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "flex-start",
		marginTop: 8,
	},
	outerContainer: {
		marginBottom: 20,
	},
	courseTypeContainer: {
		alignItems: "center",
		marginBottom: 8,
	},
});

export default class AltCourseTile extends Component {
	static propTypes = {
		course: PropTypes.shape({
			name: PropTypes.string.isRequired,
			primaryCategoryName: PropTypes.string.isRequired,
			primaryCategoryID: PropTypes.string.isRequired,
			id: PropTypes.string.isRequired,
			image: PropTypes.object,
			classID: PropTypes.string.isRequired,
			captivate: PropTypes.object,
			type: PropTypes.string.isRequired,
		}),
		color: PropTypes.string,
		language: PropTypes.string.isRequired,
	};

	constructor(props) {
		super(props);
		this.strings = props.language === languages.es ? spanish : english;
	}

	_categoryColor = category => {
		if (!category) {
			return colors.babyBlue;
		}
		const catColor =
			categoryColors[category.toLowerCase().replace(/[&/\\#,+()$~%.'":*?<>{}\s’]/g, "")];
		if (!catColor) {
			return colors.babyBlue;
		}
		return catColor;
	};

	render() {
		const bgStyle = StyleSheet.create({
			bg: { backgroundColor: this._categoryColor(this.props.course.primaryCategoryName) },
		});

		const bgTypeStyle = StyleSheet.create({
			bg: {
				backgroundColor: typeColors[this.props.course.type],
				width: "14px",
				height: "13px",
				display: "inline-block",
				verticalAlign: "text-bottom",
			},
		});

		const tileCss = css([styles.container, bgStyle.bg]);

		return (
			<div className={css(styles.outerContainer)}>
				<div className={tileCss}>
					<a
						className={css(styles.link)}
						href={`/class/${this.props.course.id}?language=${this.props.language}`}
					>
						<div className={css(styles.courseTypeContainer)}>
							<div className={css(styles.courseTypeText)}>
								<span className={css(bgTypeStyle.bg)} />
								<span className={css([styles.courseTypeBackground])}>
									{this.strings.type[this.props.course.type].toUpperCase()}
								</span>
							</div>
						</div>
						<img
							src={this.props.course.image.url1x}
							srcSet={
								this.props.course && this.props.course.image
									? `${this.props.course.image.url2x} 2x, ${
											this.props.course.image.url3x
										} 3x`
									: ""
							}
							width="100%"
							alt="Class"
						/>
						<div className={css(styles.infoContainer)}>
							<div>
								<div className={css(styles.categoryText)}>
									{this.props.course.primaryCategoryName}
								</div>
								<div className={css(styles.courseTitle)}>
									{this.props.course.name}
								</div>
							</div>
						</div>
					</a>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/AltCourseTile.js